import { React, useEffect } from "react";
import { useParams } from "react-router-dom";
import ReactGA from "react-ga4";

const FileDownload = () => {
  const params = useParams();
  const filename = "/docs/curriculum-package/eduztuition-"+params.level+"-curriculum-package.pdf"

  ReactGA.event("CurriculumPackage", {
    event_action: "download",
    event_category: "CurriculumPackage",
    event_source: "direct",
    event_label: params.level
  })

  useEffect(() => {
    window.location.href = filename;
  }, []);

  return <p>Downloading {params.level} curriculum package...</p>;
};

export default FileDownload;
  